/**
 * @author rmh
 * 模块说明：采购单管理
 */
import { Service } from '@/tools'

export class purchaseOrderListService<T extends TProcurementStrategy.purchaseOrderList> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(
    url: `${P}/${keyof TProcurementStrategy.purchaseOrderList}`,
    data?: TCommon.Json,
    toast?: string
  ) {
    return this.post(url, data, toast)
  }

  /**
   * 模块说明：列表相关接口
   */
  purchasePage = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiPage', data)
  }

  /**
   * 模块说明：新增相关接口
   */
  purchaseAddOrder = <K extends T['ApiAdd']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiAdd', data, '操作成功')
  }

  /**
   * 模块说明：详情相关接口
   */
  purchaseDetail = <K extends T['ApiDetail']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiDetail', data)
  }

  /**
   * 模块说明：查询商品信息
   */
  purchaseCommodity = <K extends T['ApiCommodity']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiCommodity', data)
  }

  /**
   * 模块说明：采购单-了结
   */
  purchaseEnd = <K extends T['ApiEnd']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiEnd', data, '操作成功')
  }

  /**
   * 模块说明：采购单-明细导出
   */
  purchaseExport = <K extends T['ApiExport']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiExport', data, '操作成功')
  }

  /**
   * 模块说明：回告上传
   */
  importExcel = <K extends T['ApiImportExcel']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiImportExcel', data, '操作成功')
  }

  /**
   * 模块说明：回告调整
   */
  purchaseFeedBackAdjustImport = <K extends T['ApiFeedBackAdjustImport']>(data: K['req']): Promise<K['res']['data']> => {
    return this.post2('v1/ApiFeedBackAdjustImport', data)
  }

  /**
   * 模块说明：查询采购单关联单据
   */
  purchaseFeedBackReceipt = <K extends T['ApiReceipt']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiReceipt', data)
  }
}
